import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFastDelivery: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFastDelivery"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H21V21H12V19H19V5H16V10H8V5H5V10H3V3ZM3 13H9V15H3V13ZM1 16H7V18H1V16ZM3 19H9V21H3V19Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFastDelivery;
